import * as React from 'react';
import S from 's-js';
import { TZUtils } from 'lib/tzutils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';

import { DispatchDashboardTab } from 'server/enums/DispatchDashboardTab';

import { parseDate } from 'common/services/routeParams';
import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { DispatchDashboard, DispatchDashboardParams } from './model';
import { DispatchDashboardView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';

export function DispatchDashboardRoute(
    model : (params : DispatchDashboardParams) => DispatchDashboard,
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute {
    const m = model(inboundParams(request, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper} navbarTab={NavbarTab.Pilots}>
                <DispatchDashboardView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location, tzutils : TZUtils) : DispatchDashboardParams {
    const id = +(request.params['id'] || 0),
        pjoId = +(request.params['pjo'] || 0),
        pjoFlip = request.params['pjoFlip'],
        dispatchEventId = +(request.params['dispatchevt'] || 0),
        // TH 04/12/2017 -- We used to expect a boolean 'historical' param.
        // I'm changing that to a numeric 'tab' param.
        // This will break any users who saved the History tab URL in their browser.
        // Oh well.
        tab = request.params['tab'],
        range = request.params['range'],
        from = request.params['from'],
        to = request.params['to'],
        filter = request.params['filter'];

    return {
        id,
        pjoId,
        pjoFlip: pjoFlip === undefined || !pjoId ? null : +pjoFlip,
        dispatchEventId,
        tab: tab === undefined ? DispatchDashboardTab.Movements : +tab,
        searchParams: {
            range: range !== undefined ? parseDateRange(range) :
                +(tab || 0) === DispatchDashboardTab.BillingWorklist ? DateRange.AllDates :
                DateRange.ThisWeek,
            from: from !== undefined ? parseDate(from, tzutils) : undefined,
            to: to !== undefined ? parseDate(to, tzutils) : undefined,
            filter
        }
    };
}

function outboundParams(request : Location, m : DispatchDashboard) {
    const params = {} as LocationParams;
    params['id'] = '' + m.Id;

    if (m.Tab !== DispatchDashboardTab.Movements) params['tab'] = '' + m.Tab;

    // Sample internal state of DateRangeSelector and Filter, then subscribe to our ModelKey.
    // That way the URL params for date and text searches only update when the user executes
    // their new search.
    S.sample(() => {
        if (m.DateRangeSelector) {
            const defaultRange = m.Tab === DispatchDashboardTab.BillingWorklist ? DateRange.AllDates : DateRange.ThisWeek;
            m.DateRangeSelector && outboundDateRangeParams(m.DateRangeSelector, params, defaultRange, { range: 'range', from: 'from', to: 'to' });
        }
        if (m.Filter && m.Filter()) params['filter'] = m.Filter();
    });
    m.ModelKey();

    const selectedItem = m.SelectedItemKey();
    if (selectedItem) {
        if (selectedItem.pjoId) params['pjo'] = '' + selectedItem.pjoId;
        if (selectedItem.dispatchEventId) params['dispatchevt'] = '' + selectedItem.dispatchEventId;
    }

    if (m.PilotJobOrderDetails() &&
        m.PilotJobOrderDetails()!.Flipped() &&
        m.PilotJobOrderDetails()!.BackPage() !== null) {
        params['pjoFlip'] = '' + m.PilotJobOrderDetails()!.BackPage()!;
    }

    return new Location(request.name, params);
}



// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/route.tsx